import NumeralService from '/@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';

export class EstimatedFinalTaxesLiabilityMeta {
  /**
   * @var {string}
   */
  federalTax;

  /**
   * @var {float}
   */
  provincialTax;

  constructor(model = {}) {
    this.federalTax = model.federalTax;
    this.provincialTax = model.provincialTax;
  }

  /**
   * @returns {string}
   */
  get formattedFederalTaxAmount() {
    return NumeralService.formatValue(this.federalTax ?? 0, ColumnFormat.FORMAT_CURRENCY, 2);
  }

  /**
   * @returns {string}
   */
  get formattedProvincialTaxAmount() {
    return NumeralService.formatValue(this.provincialTax ?? 0, ColumnFormat.FORMAT_CURRENCY, 2);
  }
}
